module.exports = __webpack_public_path__ + "static/media/venetian09.48eb3e49.png";